import React from 'react';

import colors from 'pubweb-react-components/dist/styles/colors';

import SVGCloseIcon from 'pubweb-react-components/dist/images/svg/Nav/CloseIcon';
import Triangle from 'pubweb-react-components/dist/images/svg/Triangle';

import quizImage1 from '../../images/quiz/ch-him2-lp-quiz-1.jpg';
import quizImage2 from '../../images/quiz/ch-him2-lp-quiz-2.jpg';
import quizImage3 from '../../images/quiz/ch-him2-lp-quiz-3.jpg';
import quizImage4 from '../../images/quiz/ch-him2-lp-quiz-4.jpg';
import quizImage5 from '../../images/quiz/ch-him2-lp-quiz-5.jpg';
import questions from '../../utils/quizQuestions';

import QuizContainer from './Quiz.styled';

import QuizForm from './QuizForm';

// const relativePath = process.env.RELATIVE_PATH;

export class Quiz extends React.Component {
    constructor(props) {
        super(props);
        let currentQuestion = questions[0];
        this.state = {
            currentQuestion: 0,
            questions,
            answers: [],
            numberPicked: '',
            email: '',
            name: '',
            redirectLink: null,
            source: this.props.source,
            buttonDisabled: true,
            processing: false,
            quizImages: [
                quizImage1,
                quizImage2,
                quizImage3,
                quizImage4,
                quizImage5
            ],
            bgColor: currentQuestion.bgColor
        };
        this.handlePreviousClick = this.handlePreviousClick.bind(this);
        this.handleNextClick = this.handleNextClick.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }
    componentDidMount() {
        const currentQuestion = this.state.currentQuestion;
        if (currentQuestion) {
            let bgColor = this.state.questions[currentQuestion] ? this.state.questions[currentQuestion].bgColor : 'transparent';
            this.setState({ bgColor: bgColor });
        }
    }
    handleNextClick(ev) {
        ev.preventDefault();
        let requestedQuestion = this.state.currentQuestion + 1;
        this.setState({ currentQuestion: requestedQuestion });
    }
    handlePreviousClick(ev) {
        ev.preventDefault();
        let requestedQuestion = this.state.currentQuestion - 1 < 0 ? 0 : this.state.currentQuestion - 1;
        let bgColor = this.state.questions[requestedQuestion].bgColor;
        this.setState({ currentQuestion: requestedQuestion, bgColor });
    }
    handleChange(question, answer, event) {
        this.setState({ numberClicked: answer + 1 });

        this.setState({ [question]: event.target.value }, () => {
            setTimeout(() => {
                let bg = this.state.questions[this.state.currentQuestion + 1]
                    ? this.state.questions[this.state.currentQuestion + 1].bgColor
                    : "transparent";
                let bgClass = this.state.questions[this.state.currentQuestion + 1]
                    ? ""
                    : "auto";
                this.setState({
                    currentQuestion: this.state.currentQuestion + 1,
                    bgColor: bg,
                    bgClass,
                    numberClicked: ""
                });
            }, 200);
        });
    }
    renderFormError() {
        if (this.props.apiError) {
            return (
                <p className="form-error">We are unable to process your request at this time. Please try again later.</p>
            )
        }
    }
    renderFormQuestion() {
        if (this.state.processing) {
            return (
                <div className='form'>
                    <h2 className='form-header-waiting'>One moment while we compile your personalized home results.</h2>
                </div>
            )
        }
        else if (this.state.currentQuestion === 5) {

            const redirectUrl = `/pages/quiz/thankyou`;

            return <QuizForm
                isQuizForm={true}
                category=''
                redirectUrl={redirectUrl}
                buttonColor={colors.secondaryKiddiePool}
                buttonHoverColor={colors.primaryClaytonBlue}
                className='form-modal'
            />;
        }
        else {
            const question = this.state.questions[this.state.currentQuestion];
            return (
                <form className="quiz">
                    <div className="quiz-question-number">
                        {this.state.currentQuestion > 0 ? <span className='prev' onClick={this.handlePreviousClick}><Triangle svgSize={'22px'} svgColor={'#fff'} /></span> : null}
                        <div className="question-number">{this.state.currentQuestion + 1}/{this.state.questions.length}</div>
                        {/* eslint-disable-next-line */}
                        <a href='javascript:void(0);' className='modal-close-button' onClick={this.props.exitModal}>
                            <SVGCloseIcon color={colors.grayscaleCoolGray11} size="12" />
                        </a>
                    </div>
                    <div className="quiz-content">
                        <h2 className="quiz-question">{question.question}</h2>
                        <img src={this.state.quizImages[this.state.currentQuestion]} alt="Clayton Built Home" className="quiz-image"></img>
                        <fieldset className="fieldset">
                            <legend hidden>{question.params}</legend>
                            {question.choices.map((choice, i) => (
                                <div key={i} className="answer">
                                    <input
                                        onClick={this.handleChange.bind(this, `q${question.number}`, choice.number)}
                                        className="answer-radio"
                                        checked={this.state.answers[this.state.currentQuestion] === choice.number}
                                        id={`q${question.number}a${i}`}
                                        ref={`q${question.number}`}
                                        name={`q${question.number}`}
                                        value={choice.value}
                                        type="radio"
                                    ></input>
                                    <label
                                        htmlFor={`q${question.number}a${i}`}
                                        className="answer-label"
                                    >
                                        <div className="answer-radio-sub"></div>
                                        <div className="answer-label-text">{choice.description}</div>
                                    </label>
                                </div>
                            ))}
                        </fieldset>
                    </div>
                </form>
            )
        }
    }
    render() {
        return (
            <QuizContainer bgColor={this.state.bgColor}>
                {this.renderFormQuestion()}
            </QuizContainer>
        );
    }
};
export default Quiz;